import ListDeliveryOrders from "../../../../components/@documents/delivery_orders/ListDeliveryOrders";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DeliveryOrdersPage() {

    return (
        <ListDeliveryOrders 
            routeType={routeTypes.admin}
        />
    )
}